
import Organizational from './organizational'
import Individual from './individual'

export default {
  Individual,
  Organizational
}
